module.exports = __webpack_public_path__ + "static/media/password@3x.cf9cd547.png";